module.exports = __webpack_public_path__ + "static/media/error-notification.76133e74.svg";